import React, { useEffect, useState } from 'react';
import { FieldValues, Path } from 'react-hook-form';
import CheckboxList, { FilterListItem } from '../../CheckboxList';
import { cameraService } from '../../../../services/central-api/cameras';

function DownloadTagsList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getSimplifiedDownloadTags() {
        try {
            const tags = await cameraService.getSimplifiedDownloadTags();
            setItems(tags.map(tag => ({ label: tag.name, value: tag.id, color: tag.color })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getSimplifiedDownloadTags();
    }, []);

    return <CheckboxList name={name} items={items} renderBadge isLoading={isLoading} />;
}

DownloadTagsList.getCount = CheckboxList.getCount;

export default DownloadTagsList;
